import { render, staticRenderFns } from "./ProfileCatalogSubGroup.vue?vue&type=template&id=9fa8f95e&"
import script from "./ProfileCatalogSubGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileCatalogSubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports